// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ecd75c1e","732":"99e1ecb0","977":"adb1c5d1"}[chunkId] + ".chunk.js";
};